import React, { Fragment, useEffect } from 'react';
import { useParams, Route } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_ARTICULO } from '../../graphql/actions/articulo';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// core components
import GridContainer from '../UI/Grid/GridContainer';
import GridItem from '../UI/Grid/GridItem';
import Badge from '../UI/Badge/Badge';
import Button from '../UI/CustomButtons/Button';
import Spinner from '../UI/Spinner/Spinner';
import Notification from '../Notification/Notification';
import ArticuloComment from './ArticuloComment';

import sectionFullDataStyle from '../../assets/jss/coscef/views/articuloSections/sectionDetailsStyle';

const useStyles = makeStyles(sectionFullDataStyle);

const ArticuloDetails = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);
  const classes = useStyles();
  const params = useParams();

  const {
    loading: loadingArticulo,
    error: errorArticulo,
    data: dataArticulo,
  } = useQuery(GET_ARTICULO, {
    variables: {
      id: props.match.params.id,
    },
    skip: !props.match.params.id,
    errorPolicy: 'all',
  });

  let seccionArticulo = null;
  let seccionInfo = null;
  let seccionComentarios = null;
  let showNotification = null;

  if (loadingArticulo) {
    seccionArticulo = (
      <div className={classes.container}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <Spinner color='gray' />;
          </GridItem>
        </GridContainer>
      </div>
    );

    seccionInfo = null;
    seccionComentarios = null;
  }

  if (errorArticulo) {
    seccionArticulo = (
      <div className={classes.container}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title}>Error buscando el articulo.</h2>
          </GridItem>
        </GridContainer>
      </div>
    );

    seccionInfo = null;
    seccionComentarios = null;

    showNotification = errorArticulo.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorArticulo ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataArticulo && dataArticulo.getArticulo) {
    const { getArticulo } = dataArticulo;
    //console.log(getArticulo);
    seccionArticulo = (
      <GridContainer justify='center'>
        <GridItem xs={12} sm={8} md={8} key={getArticulo._id}>
          <h3 className={classes.title}>{getArticulo.titulo}</h3>
          <p>Por {getArticulo.autor}</p>
          <div
            dangerouslySetInnerHTML={{ __html: getArticulo.contenido }}
          ></div>
        </GridItem>
      </GridContainer>
    );

    seccionInfo = (
      <GridContainer justify='center'>
        <GridItem xs={12} sm={10} md={8}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <div className={classes.blogTags}>
                Etiquetas:{' '}
                {getArticulo.etiquetas.map((etqta) => (
                  <Badge color='gray' key={getArticulo._id}>
                    {etqta}
                  </Badge>
                ))}
              </div>
            </GridItem>
          </GridContainer>
          <hr />
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <h4 className={classes.cardTitle}>{getArticulo.autor}</h4>
              <p className={classes.description}>
                {getArticulo.descripcionAutor}
              </p>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    );

    seccionComentarios = (
      <Fragment>
        <Route path={`/articulo/${params.id}`} exact>
          <GridContainer>
            <GridItem xs={12} sm={12} md={10}>
              <Button
                color='dark'
                round
                className={classes.floatRight}
                onClick={(e) => {
                  e.preventDefault();
                  props.history.push(`/articulo/${params.id}/comentarios`);
                }}
              >
                Ver Comentarios
              </Button>
            </GridItem>
          </GridContainer>
        </Route>
        <Route path={`/articulo/${params.id}/comentarios`}>
          <ArticuloComment articuloId={params.id} estaAuth={props.isAuth} />
        </Route>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <div className={classes.main} id='main-panel'>
        <div className={classes.container}>
          <div className={classes.section}>{seccionArticulo}</div>
          <div className={classes.section}>{seccionInfo}</div>
          <div className={classes.section}>{seccionComentarios}</div>
        </div>
      </div>
      <div className={classes.sectionfinal}>{showNotification}</div>
    </Fragment>
  );
};

export default ArticuloDetails;
